import React from 'react'
import { Svg } from '../../application'
import getText from '../strings'
import styled from 'react-emotion'

const Wrapper = styled('div')`
  text-align: center;
  font-size: .8em;
`

export default () => (
  <Wrapper>
    <Svg icon="lock-ssl" /> {getText('wizard', 'footer', 'sslInformation')}
  </Wrapper>
)